/*************************************************/
/* FILE REQUEST                                  */
/*************************************************/

export function fileRequest() {
    const componentSelector = '.file-request-component';
    const formSelector = '.file-request-component__form';
    const dataSelector = '.file-request-component__data';
    const fieldSelector = '.file-request-component__field';
    const fileSelector = '.file-request-component__select--file';
    const languageSelector = '.file-request-component__select--language';

    const setLanguages = (select, field, files, placeholder) => {
        select.length = 1;

        files.forEach(file => {
            const option = document.createElement('option');
            option.value = file.code;
            option.textContent = file.name;
            option.dataset.url = file.url;
            select.add(option);
        });

        if (placeholder) select.options[0].textContent = placeholder;

        select.value = '';
        if (files.length === 1) select.selectedIndex = 1;

        select.disabled = files.length === 0;
        if (field) field.hidden = files.length < 2;
    };

    const selectedUrl = (select) => select.selectedOptions[0]?.dataset.url;

    const init = () => {
        document.querySelectorAll(componentSelector).forEach(component => {
            const form = component.querySelector(formSelector);
            const dataElement = component.querySelector(dataSelector);
            if (!form || !dataElement) return;

            let groups = [];
            try {
                groups = JSON.parse(dataElement.textContent) || [];
            } catch {
                return;
            }
            if (!groups.length) return;

            const fileSelect = form.querySelector(fileSelector);
            const languageSelect = form.querySelector(languageSelector);
            if (!fileSelect || !languageSelect) return;

            const languageField = languageSelect.closest(fieldSelector);
            const placeholder = languageSelect.options[0]?.textContent;

            setLanguages(languageSelect, languageField, [], placeholder);

            fileSelect.addEventListener('change', () => {
                const group = groups.find(x => x.name === fileSelect.value);
                setLanguages(languageSelect, languageField, group ? group.files : [], placeholder);
            });

            form.addEventListener('submit', event => {
                event.preventDefault();

                const url = selectedUrl(languageSelect);
                if (!url) return;

                window.open(url, '_blank');

                fetch(form.action, {
                    method: 'POST',
                    body: new FormData(form),
                }).catch(() => { });

                form.reset();
                setLanguages(languageSelect, languageField, [], placeholder);
            });
        });
    };

    init();
}
